import { getWindow } from '../dom/getWindow';

const persistentStorage = new Proxy<{
  remove(prop: string): unknown;
  [key: string]: unknown;
}>(
  {
    remove(prop) {
      localStorage.removeItem(prop);
    },
  },
  {
    get(_, prop) {
      try {
        const value = localStorage.getItem(String(prop));
        if (!value) return undefined;
        return JSON.parse(value) as unknown;
      } catch {
        return undefined;
      }
    },
    set(_, prop, value) {
      localStorage.setItem(String(prop), JSON.stringify(value));
      return true;
    },
  },
);

declare global {
  interface Window {
    persistentStorage: typeof persistentStorage;
  }
}

if (typeof window !== 'undefined') {
  getWindow().persistentStorage = persistentStorage;
}

export default persistentStorage;
